module.exports = __webpack_public_path__ + "img/group6@2x.4461ad0a.png";